import axios, { AxiosInstance } from 'axios';
import { registerScouterLegacy } from './legacyMike';

/** Emitido quando o refresh renova o access token. Ouvido pelo AuthProvider. */
export const TOKEN_REFRESHED_EVENT = 'scout:token-refreshed';

export interface TokenRefreshedDetail {
  accessToken: string;
  refreshToken: string;
}

export const setupAuthInterceptors = (apiInstance: AxiosInstance): void => {
  apiInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('@Scout:accessToken');

      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  apiInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const refreshToken = localStorage.getItem('@Scout:refreshToken');

          if (refreshToken) {
            const refreshResponse = await axios.post(
              `${process.env.REACT_APP_FIGHT_AUTH_API}/auth/refresh`,
              { token: refreshToken },
            );

            const {
              accessToken,
              refreshToken: newRefreshToken,
            } = refreshResponse.data;

            localStorage.setItem('@Scout:accessToken', accessToken);
            localStorage.setItem('@Scout:refreshToken', newRefreshToken);

            // O socket autentica só no handshake, então a renovação precisa
            // chegar ao AuthContext e daí à conexão — sem isso, um evento mais
            // longo que o TTL do access token derruba a escrita de actions.
            window.dispatchEvent(
              new CustomEvent(TOKEN_REFRESHED_EVENT, {
                detail: { accessToken, refreshToken: newRefreshToken },
              }),
            );


            // Best-effort: uma queda da v1 não pode derrubar a sessão no meio
            // do evento — o refresh em si já foi bem-sucedido acima.
            await registerScouterLegacy('scouter', accessToken);

            originalRequest.headers.Authorization = `Bearer ${accessToken}`;

            return apiInstance(originalRequest);
          }
        } catch (refreshError) {
          localStorage.removeItem('@Scout:accessToken');
          localStorage.removeItem('@Scout:refreshToken');
          window.location.href = '/';
          return Promise.reject(refreshError);
        }

        localStorage.removeItem('@Scout:accessToken');
        localStorage.removeItem('@Scout:refreshToken');
        window.location.href = '/';
      }

      return Promise.reject(error);
    },
  );
};
